import { WarehouseActivityRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class WarehouseActivityService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new WarehouseActivityRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	adjustInventory(warehouseActivities) {
		var url = this.routeService.adjustInventory(warehouseActivities);
		return this.apiClient.post(url, warehouseActivities);
	}

	receiveShipment(warehouseActivity) {
		var url = this.routeService.receiveShipment(warehouseActivity);
		return this.apiClient.post(url, warehouseActivity);
	}
}

export default WarehouseActivityService;
